import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  Typography,
  Collapse,
  IconButton,
  Checkbox,
  FormControl,
  FormControlLabel,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
} from "@mui/material";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";
import { CiCirclePlus } from "react-icons/ci";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { PiCopyFill } from "react-icons/pi";
import { FaClone } from "react-icons/fa6";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import {
  // fetchAllEntities,
  filterEntities, postdatas } from "../../apis/apiService";
import { toast } from "react-toastify";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import SearchBar from "../../components/SearchBar";
// import TableDownloader from "../../components/TableDownloader";
// import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import Loader from "../../components/common/Loader";
import { red, teal } from "@mui/material/colors";
import { IOSSwitch } from "./PortalUsers";
import { CommonDeactivate } from "../../components/common/CommonDelete";
import { useFetchClientCompanyNameQuery } from "../../slice/logdetailSlice";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTheme } from "../../ThemeContext";

export const AddClientUser = ({
  showCompany,
  onApply,
  onClear,
  onCancel,
  fetchClient,
}) => {
  const [company, setCompany] = useState([]);
  const [loading, setLoading] = useState(false);
     const [openModal, setOpenModal] = useState(false);
    const [inviteLink, setInviteLink] = useState("");

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      email: "",
      FirstName: "",
      LastName: "",
      CompanyName: "",
      RatePerHour: null,
      CostPerHour: null,
      Projects: "",
    },
  });

  const { data: clientCompanyList = [], refetch: client_company_list_refetch } =
    useFetchClientCompanyNameQuery();
  const ProjectNameOptions = useSelector(
    (state) => state.selectOptions?.ProjectNameOptions
  );
  // console.log("ProjectNameOptions", clientCompanyList);
  const onInviteMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => handleInvite(data, false))();
  };

  const handleInvite = async (data, closePage = true) => {
    const requestData = {
      email: data.email,
      first_name: data.FirstName,
      last_name: data.LastName,
      rate_per_hour: data.RatePerHour,
      cost_per_hour: data.CostPerHour,
      company_list_id: data.CompanyName,
      projects: data.Projects,
    };
    setLoading(true);
    try {
      const response = await postdatas("client", "add", requestData);
      toast.success(response.message);
      fetchClient();
      reset(); // Reset form fields
      if (closePage) {
        onCancel();
      }
    } 
    catch (error) {
      console.error("error_in_settings_user", error);
      toast.error(error.response.data.message);
    } 
    finally {
      setLoading(false);
    }
  };

  // const fetchCompany = async () => {
  //   try {
  //     const response = await fetchAllEntities("getCompanyList");
  //     // // //console.log()(response,'responseCompany');

  //     if (response?.data) {
  //       setCompany(response?.data);
  //       // //console.log()(company, "responseCompany");
  //     } else {
  //       console.error("Invalid response data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching tasks:", error);
  //   }
  // };

  useEffect(() => {
    if (clientCompanyList) {
      setCompany(clientCompanyList);
    }
    // fetchCompany();
  }, [clientCompanyList]);
  const onSubmit = async (data) => {
    // handleInvite(data, true);
    const requestData = {
      email: data.email,
      first_name: data.FirstName,
      last_name: data.LastName,
      rate_per_hour: data.RatePerHour,
      cost_per_hour: data.CostPerHour,
      company_list_id: data.CompanyName,
      projects: data.Projects,
    };

    setLoading(true);
    try {
      // Call the API to create the entity
      const response = await postdatas("client", "add", requestData);
      // toast.success(response.message);
      // onApply(response.data)
      setInviteLink(response.invite_url);
      reset();
      fetchClient();
      setOpenModal(true);
    } 
    catch (error) {
      // console.error("error_in_settings_user", error);

      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };


     const handleCopy = () => {
      navigator.clipboard.writeText(inviteLink);
      toast.success("Link copied to clipboard!");
    };
  
    const handleClose = () => {
      setOpenModal(false);
      setInviteLink("");
       onCancel();
    };

  const companyLists = () => {
    showCompany();
  };

  return (
    <div className="">
      <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
              <DialogTitle>Invitation Link</DialogTitle>
              <DialogContent>
                <Typography sx={{ mb: 1 }}>
                  User invited successfully! Copy the link below:
                </Typography>
                <TextField
                  fullWidth
                  value={inviteLink}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleCopy}>
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} color="primary" variant="outlined">
                  Close
                </Button>
              </DialogActions>
            </Dialog>

      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Add as a contact
          </div>
        </button>
      </div>

      <div className="bg-white px-4 pb-5 pt-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                <div className="col-md-12 ">
                  <label htmlFor="email" className="form-label">
                    Email ID
                    <span className=" errorMsg">*</span>
                  </label>
                  <TextField
                    type="email"
                    id="email"
                    placeholder="Enter email"
                    className="form-control"
                    {...control.register("email", {
                      required: "Email is required",
                    })}
                  />
                  {errors.email && (
                    <span className=" errorMsg">{errors.email.message}</span>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="First Name" className="form-label">
                    First Name <span className=" errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    placeholder="First name"
                    id="FirstName"
                    className="form-control"
                    {...control.register("FirstName", {
                      required: "First name is required ",
                    })}
                  />
                  {errors.FirstName && (
                    <span className=" errorMsg">
                      {errors.FirstName.message}
                    </span>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="Last Name" className="form-label">
                    Last Name <span className=" errorMsg">* </span>
                  </label>
                  <TextField
                    type="text"
                    id="LastName"
                    placeholder="Last name"
                    className="form-control"
                    {...control.register("LastName", {
                      required: "Last name is required ",
                    })}
                  />
                  {errors.LastName && (
                    <span className=" errorMsg">{errors.LastName.message}</span>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="Company Name" className="form-label w-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        Company Name <span className="errorMsg">*</span>
                      </span>
                      <Tooltip title="Add Client Company">
                        <span>
                          <CiCirclePlus
                            color="teal"
                            fontSize={22}
                            style={{ cursor: "pointer" }}
                            onClick={companyLists}
                          />
                        </span>
                      </Tooltip>
                    </div>
                  </label>

                  <Controller
                    name="CompanyName"
                    control={control}
                    rules={{ required: "Company name is required" }}
                    // defaultValue={null} // Default to null
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={company}
                        getOptionLabel={(option) =>
                          typeof option === "object" ? option.company_name : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          value
                            ? option.company_list_id === value.company_list_id
                            : false
                        }
                        value={
                          field.value
                            ? company.find(
                                (c) => c.company_list_id === field.value
                              ) || null
                            : null
                        }
                        onChange={(_, selectedOption) => {
                          field.onChange(
                            selectedOption
                              ? selectedOption.company_list_id
                              : null
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Company name" />
                        )}
                      />
                    )}
                  />
                  {errors.CompanyName && (
                    <span className="errorMsg">
                      {errors.CompanyName.message}
                    </span>
                  )}
                </div>
              </div>
              
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="RatePerHour" className="form-label">
                    Rate Per Hour
                  </label>
                  <div class="input-group mb-3">
                    <TextField
                      type="number"
                      id="RatePerHour"
                      placeholder="Rate per hour"
                      className="form-control"
                      {...control.register("RatePerHour", {
                        min: { value: 0, message: "Rate cannot be negative" },
                      })}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault(); // Prevent negative and exponential input
                        }
                      }}
                    />
                  </div>
                  {errors.RatePerHour && (
                    <span className="errorMsg">
                      {errors.RatePerHour.message}
                    </span>
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="CostPerHour" className="form-label">
                    Cost Per Hour
                  </label>
                  <div class="input-group mb-3">
                    <TextField
                      type="number"
                      id="CostPerHour"
                      placeholder="Cost per hour"
                      className="form-control"
                      {...control.register("CostPerHour", {
                        min: { value: 0, message: "Cost cannot be negative" },
                      })}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault(); // Prevent negative and exponential input
                        }
                      }}
                    />
                  </div>

                  {errors.CostPerHour && (
                    <span className="errorMsg">
                      {errors.CostPerHour.message}
                    </span>
                  )}
                </div>
              </div>
              
              <div className="mt-5 mb-5">
                <h5 className="Settings_project_field">All Projects</h5>
                <div className="col-md-12 pt-4">
                  <Controller
                    name="Projects"
                    control={control}
                    rules={{ required: "Project name  is required" }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Projects"
                        options={ProjectNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        value={
                          (value || []).map((id) =>
                            ProjectNameOptions.find(
                              (opt) => opt.project_id === id
                            )
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (project) => project.project_id
                          );
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Projects Name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                  {errors.Projects && (
                    <span className="errorMsg">{errors.Projects.message}</span>
                  )}
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? "Inviting..." : "Invite"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    // onClick={onCancel}
                    onClick={onInviteMore}
                    disabled={loading}
                  >
                    Invite more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export const AddClientCompany = ({
  onApply,
  onClear,
  onCancel,
  ProjectID,
  fetchClient,
}) => {
  const [budgetOpen, setBudgetOpen] = useState(true);
  const [ProjectOpen, setProjectOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    clearErrors,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      ClientCompanyName: "",
      ClientProfile: "CLIENT",
      email: "",
      webAddress: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      country: "",
      zipCode: "",
    },
  });

  const inviteMoreCompany = async (e) => {
    e.preventDefault();
    handleSubmit((data) => handleInvite(data, false))();
  };

  const { data: clientCompanyList, refetch: client_company_list_refetch } = useFetchClientCompanyNameQuery();
  const handleInvite = async (data, closePage = true) => {
    const requestData = {
      company_name: data.ClientCompanyName,
      profile: data.ClientProfile,
      email: data.email,
      webAddress: data.webAddress,
      address_1: data.addressLine1,
      address_2: data.addressLine2,
      city: data.city,
      state: data.state,
      country: data.country,
      zip_code: data.zipCode,
    };
    setLoading(true);
    try {
      // Call the API to create the entity
      const response = await postdatas("company", "add", requestData);
      toast.success(response.message);
      reset();
      // onCancel();
      fetchClient();
      client_company_list_refetch();
    } 
    catch (error) {
      // Show error toast
      // const errorMessage = error.message || 'Unknown error';
      // toast.error(`Error creating project: ${errorMessage}`);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    const requestData = {
      company_name: data.ClientCompanyName,
      profile: data.ClientProfile,
      email: data.email,
      webAddress: data.webAddress,
      address_1: data.addressLine1,
      address_2: data.addressLine2,
      city: data.city,
      state: data.state,
      country: data.country,
      zip_code: data.zipCode,
    };

    setLoading(true);
    try {
      // Call the API to create the entity
      const response = await postdatas("company", "add", requestData);
      toast.success(response.message);
      reset();
      onCancel();
      fetchClient();
      client_company_list_refetch();
    } 
    catch (error) {
      // Show error toast
      // const errorMessage = error.message || 'Unknown error';
      // toast.error(`Error creating project: ${errorMessage}`);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset();
  };

  const handleBudgetToggle = () => {
    setBudgetOpen((prev) => !prev);
  };

  const handleProjectToggle = () => {
    setProjectOpen((prev) => !prev);
  };

  const [search, setSearch] = useState("");

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Add New Client Company
          </div>
        </button>
      </div>

      <div className="bg-white px-4 pb-5 pt-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row">
                <div className="col-12">
                  <label htmlFor="ClientCompanyName" className="form-label">
                    Client Company Name<span className="errorMsg"> *</span>
                  </label>
                  <TextField
                    type="text"
                    id="ClientCompanyName"
                    placeholder="Enter company name"
                    className="form-control"
                    {...register("ClientCompanyName", {
                      required: "Client Company Name is required",
                    })}
                  />
                  {errors.ClientCompanyName && (
                    <span className="errorMsg">
                      {errors.ClientCompanyName.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="row mt-3">
                <div>
                  <Button
                    onClick={handleBudgetToggle}
                    endIcon={
                      budgetOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />
                    }
                    fullWidth
                    variant="standared"
                    sx={{ marginBottom: 2 }}
                    className="d-flex justify-content-start p-0"
                  >
                    Client Information
                  </Button>

                  <Collapse in={budgetOpen}>
                    <div className="col-md-12 ">
                      <label htmlFor="email" className="form-label">
                        Email <span className="errorMsg"> *</span>
                      </label>
                      <TextField
                        type="email"
                        id="email"
                        placeholder="Enter email"
                        className="form-control"
                        {...control.register("email", {
                          required: "Email is required",
                        })}
                      />
                      {errors.email && (
                        <span className="errorMsg">{errors.email.message}</span>
                      )}
                    </div>

                    <div className="col-md-12 mt-3">
                      <label htmlFor="ClientProfile" className="form-label">
                        Client Profile
                        <span className="errorMsg"> *</span>
                      </label>

                      <FormControl fullWidth>
                        <Controller
                          name="ClientProfile"
                          defaultValue="CLIENT"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="ClientProfile-label"
                              id="ClientProfile"
                              IconComponent={ExpandMore}
                              onChange={(e) => {
                                field.onChange(e); // Set the value for the field
                                clearErrors("ClientProfile"); // Clear the error if the user selects a value
                              }}
                            >
                              <MenuItem value="CLIENT">CLIENT</MenuItem>
                              {/* Add other options as needed */}
                            </Select>
                          )}
                          rules={{ required: "Client Profile is required" }}
                        />
                        {errors.ClientProfile && (
                          <span className="errorMsg">
                            {errors.ClientProfile.message}
                          </span>
                        )}
                      </FormControl>
                    </div>
                  </Collapse>
                </div>
              </div>

              <div className="row mt-3">
                <div>
                  <Button
                    onClick={handleProjectToggle}
                    endIcon={
                      ProjectOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />
                    }
                    fullWidth
                    variant="standared"
                    sx={{ marginBottom: 2 }}
                    className="d-flex justify-content-start p-0"
                  >
                    Client Information
                  </Button>

                  <Collapse in={ProjectOpen}>
                    <div className="col-md-12  mt-3">
                      <label className="form-label">Web Address</label>{" "}
                      {/* <span className="errorMsg"> *</span> */}
                      <TextField
                        className="form-control"
                        placeholder="Address"
                        {...register(
                          "webAddress"
                          //  {
                          // required: "Web Address is required",
                          // }
                        )}
                      />
                      {/* {errors.webAddress && (
                        <p className="errorMsg">{errors.webAddress.message}</p>
                      )} */}
                    </div>

                    <div className="col-md-12  mt-3">
                      <label className="form-label">
                        Address Line 1
                        {/* <span className="errorMsg"> *</span> */}
                      </label>
                      <TextField
                        className="form-control"
                        placeholder="Address line 1"
                        {...register(
                          "addressLine1"
                          // {
                          // required: "Address Line 1 is required",
                          // }
                        )}
                      />
                      {/* {errors.addressLine1 && (
                        <p className="errorMsg">
                          {errors.addressLine1.message}
                        </p>
                      )} */}
                    </div>

                    <div className="col-md-12  mt-3">
                      <label className="form-label">Address Line 2</label>
                      <TextField
                        className="form-control"
                        placeholder="Address line 2"
                        {...register("addressLine2")}
                      />
                    </div>

                    <div className="row">
                      <div className="col-md-6  mt-3">
                        <label className="form-label">
                          City
                          {/* <span className="errorMsg"> *</span> */}
                        </label>
                        <TextField
                          className="form-control"
                          placeholder="City"
                          {...register(
                            "city"
                            //    {
                            //   required: "City is required",
                            // }
                          )}
                        />
                        {/* {errors.city && (
                          <p className="errorMsg">{errors.city.message}</p>
                        )} */}
                      </div>

                      <div className="col-md-6  mt-3">
                        <label className="form-label">
                          State
                          {/* <span className="errorMsg"> *</span> */}
                        </label>
                        <TextField
                          className="form-control"
                          placeholder="State"
                          {...register(
                            "state"
                            //    {
                            //   required: "State is required",
                            // }
                          )}
                        />
                        {/* {errors.state && (
                          <p className="errorMsg">{errors.state.message}</p>
                        )} */}
                      </div>

                      <div className="col-md-6  mt-3 mb-5">
                        <label className="form-label">
                          Country
                          {/* <span className="errorMsg"> *</span> */}
                        </label>
                        <TextField
                          className="form-control"
                          placeholder="Country"
                          {...register("country")}
                        />
                        {/* {errors.country && (
                          <p className="errorMsg">{errors.country.message}</p>
                        )} */}
                      </div>

                      <div className="col-md-6  mt-3 mb-5">
                        <label className="form-label">
                          Zip Code
                          {/* <span className="errorMsg"> *</span> */}
                        </label>
                        <TextField
                          className="form-control"
                          placeholder="Zip code"
                          {...register("zipCode", {
                            // required: "Zip Code is required",
                            pattern: {
                              value: /^[0-9]+$/,
                              // message: "Zip Code must be numeric",
                            },
                          })}
                        />
                        {/* {errors.zipCode && (
                          <p className="errorMsg">{errors.zipCode.message}</p>
                        )} */}
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button type="submit" className="me-3 add_btn">
                    {loading ? "Inviting..." : "Invite"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    onClick={inviteMoreCompany}
                  >
                    Invite more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const ClientUser = ({ ProjectID }) => {
  const { isDarkMode } = useTheme();
  const { reset } = useForm();
  const [paginationModal, setPaginationModal] = useState({
    page: 0,
    pageSize: 25,
  });
  const [rows, setRows] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
const [filter, setFilter] = useState(2);
  const [projects, setProjects] = useState();
  // const [Tasks, setTasks] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeComponent, setActiveComponent] = useState("InviteClientUser");
  const [showCompany, setShowCompany] = useState(false);
  const navigate = useNavigate();
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  // const handleShowProject = () => setShowProject(true); // Open filter
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  const { role: login_user_role, id: login_user_id } = login_user;


  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {params.row.isTask && (
            <IconButton onClick={() => toggleExpandRow(params.row.id)}>
              {expandedRowId === params.row.id ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          )}
          {/* <IconButton onClick={(event) => handleMenuOpen(event, params.row.id)}>
            <MoreVertIcon />
          </IconButton> */}
        </Box>
      ),
    },
    {
      field: "name",
      headerName: "User Name",
      width: 200,
      renderCell: (params) => (
        <Box
          sx={{ cursor: params.row.isSubtask ? "pointer" : "default" }}
          onClick={() => {
            if (params.row.isTask) {
              // //console.log()("Company clicked:", params.row.name);
            } else if (params.row.isSubtask) {
              // //console.log()("Client clicked:", params.row.name);
            }
          }}
        >
          {params.value}
        </Box>
      ),
    },
    { field: "email", headerName: "Email", width: 250 },
    { field: "role", headerName: "Role", width: 150 },
    { field: "rate_per_hour", headerName: "Rate Per Hour", width: 150 },
    { field: "cost_per_hour", headerName: "Cost Per Hour", width: 150 },
    {
      field: "is_accept_invitation",
      headerName: "Invitation Status",
      width: 150,
    },
 {
  field: "invite_url",
  headerName: "Invitation Link",
  width: 160,
  renderCell: (params) => {
    const inviteUrl = params.value;
    if (!inviteUrl) return null; // Hide button if no value

    const handleCopy = () => {
      navigator.clipboard.writeText(inviteUrl);
      toast.success("Link copied to clipboard!");
    };

    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <button
          onClick={handleCopy}
          className="add_btn"
          style={{
            backgroundColor: "#00bfa6",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "500",
            lineHeight: "1",
            padding: "6px 14px",
            borderRadius: "20px",
            border: "none",
            cursor: "pointer",
            height: "32px",
            width: "70px",
          }}
        >
          Link
        </button>
      </Box>
    );
  },
},
    {
      field: "is_active",
      headerName: "Action",
      width: 200,
      align: "center",
      // headerAlign: "center", // Optional: aligns header too
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = params.value;
          return (
            <Box
              display="flex"
              alignItems="center"
              onClick={(event) => event.stopPropagation()}
            >
              <FormControlLabel
                sx={{
                  m: 1.5,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.9rem",
                  },
                }}
                control={
                  <IOSSwitch
                    sx={{ transform: "scale(0.8)" }}
                    onClick={() => toggleSwitch(params.row)}
                    checked={params.value === 1}
                  />
                }
                label={params.value === 1 ? "Active" : "Inactive"}
              />
            </Box>
          );
        }

        return null;
      },
    },
  ];

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
};


  const transformResponse = (data) => {
    // Check if data is valid
    if (!data || !Array.isArray(data)) {
      console.error("Invalid data structure:", data);
      return []; // Return an empty array if data is invalid
    }

    // Process the companies
    return data.map((company) => {
      const companyRow = {
        id: `company_${company.company_email}`, // Unique ID based on company email
        name: company.company_name,
        // email: company.company_email,
        isTask: true, // Mark as expandable row
        subtasks:
          company.clients && Array.isArray(company.clients)
            ? company.clients.map((client, index) => ({
                id: `client_${index}`, // Unique ID for each client
                name: client.user_name,
                user_name: client.user_name,
                email: client.email,
                role: client.role,
                user_id: client.client_id,
                rate_per_hour: client.rate_per_hour,
                cost_per_hour: client.cost_per_hour,
                is_accept_invitation: client.is_accept_invitation,
                invite_url: client.invite_url,
                isSubtask: true, // Mark as subtask
                parentId: `company_${company.company_email}`, // Link to parent
                is_active: client.is_active,
              }))
            : [], // Return empty array if no clients
      };

      return companyRow;
    });
  };

  const fetchSearchedTask = async (searchQuery) => {
    setLoading(true);
    try {
      const response = await filterEntities("client/show", {
        searchText: searchQuery,
      });

      if (response.status) {
        const transformedData = transformResponse(response.data);
        setRows(transformedData);
      } else {
        setRows([]);
      }
    } 
    catch (error) {
      console.error("Failed to fetch projects:", error);
      setRows([]);
    } 
    finally {
      setLoading(false);
    }
  };

  // fetchClient
const fetchClient = async () => {
  setLoading(true);
  try {
    const response = await filterEntities("client/show", {
      viewType: filter,   // <-- pass selected filter value
    });

    if (response?.data) {
      const transformedData = transformResponse(response.data);
      setRows(transformedData);
    } else {
      console.error("Invalid response data");
    }
  } 
  catch (error) {
    console.error("Error fetching tasks:", error);
  } 
  finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchClient();
  }, [filter]);
  const toggleSwitch = (row) => {
    console.log("row_value :", row);

    setSelectedUser(row);
    setOpenPopup(true);
  };

  const toggleExpandRow = (taskId) => {
    setExpandedRowId((prev) => (prev === taskId ? null : taskId));
  };

  const handleMenuOpen = (event, taskId) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(taskId);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };
  
  const handleClone = () => {
    // //console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    // //console.log()(`View task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleViewDitailstab = () => {
    // //console.log()(`View task on new tab: ${selectedTask}`);
    handleMenuClose();
  };

  const handleCopylink = () => {
    // //console.log()(`Copy task: ${selectedTask}`);
    handleMenuClose();
  };

  // const handleFilterChange = (event) => {
  //   const value = event.target.value;
  //   setFilter(value);

  //   let filteredProjects;
  //   switch (value) {
  //     case "completed":
  //       filteredProjects = rows.filter((project) => project.completion === 100);
  //       break;
  //     case "recent":
  //       filteredProjects = rows; // Modify this to sort/filter based on recent access logic
  //       break;
  //     default:
  //       filteredProjects = rows;
  //   }

  //   setProjects(filteredProjects);
  // };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedTask(value);
    } else {
      await fetchClient();
      // setIssues([]); // Clear projects if search term is empty
    }
  };

  // Flatten rows and inject subtasks when a row is expanded
  const getFlattenedRows = () => {
    const flattenedRows = [];
    rows.forEach((row) => {
      flattenedRows.push(row); // Add parent row
      if (expandedRowId === row.id) {
        row.subtasks.forEach((subtask) => {
          flattenedRows.push({ ...subtask }); // Add subtasks when expanded
        });
      }
    });
    return flattenedRows;
  };



  const handleShowProjects = (component) => {
    setActiveComponent(component); // Set which component to show
    setShowProject(true);
  };
  const handleCloseProject = () => setShowProject(false);
  // console.log("user_id_value selected task :", selectedUser);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <AddClientUser
            onCancel={handleCloseProject}
            ProjectID={ProjectID}
            fetchClient={fetchClient}
            showCompany={() => setShowCompany(true)}
            // onApply={handleAddTask}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showCompany}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >

        <Offcanvas.Body className="p-0">
          <AddClientCompany
            onCancel={() => setShowCompany(false)}
            ProjectID={ProjectID}
            fetchClient={fetchClient}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <CommonDeactivate
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        selectedUser={selectedUser}
        refetchList={fetchClient}
        deactivatePath="changeUserStatus"
        setSelectedUser={setSelectedUser}
      />
      {/* Add filter */}
        

      <div className="py-3">
        {/* <div className="d-flex justify-content-between  gap-1 pb-2 ">
            <div className="d-flex gap-2 align-items-center justify-items-start  "> */}
      <Box
        className="d-flex justify-content-between gap-1"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "12px 16px",
          marginBottom: "16px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
        }}
      >
        <div className="d-flex gap-2 align-items-center justify-items-start">
          <Select value={filter} onChange={handleFilterChange}>
            <MenuItem value={3}>All</MenuItem>
            <MenuItem value={2}>Active</MenuItem>
            <MenuItem value={1}>In-Active</MenuItem>
          </Select>
        </div>

        <div className="d-flex align-items-center">
          <SearchBar
            placeholder="Search clients"
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
            {/* <button
              className='text-decoration-none border-0 me-4 ms-4 rounded-circle project-icon-bg p-2'
              onClick={handleShowProject}
            >
              <CiCirclePlus className='text-rgbr-blue pro-icon-s' />
            </button> */}
            
          {login_user_role === "ADMIN" && (
            <ButtonGroup className="me-3 ms-2">
              <Button
                onClick={() => handleShowProjects("InviteClientUser")}
                className="AddButton rounded-start rounded-0"
              >
                Invite Client User
              </Button>
              <Dropdown>
                <Dropdown.Toggle
                  split
                  className="AddButton py-2 rounded-0 rounded-end"
                  id="dropdown-split-button"
                />
                  {/* <Dropdown.Menu
                  // style={{
                  //   backgroundColor: "var(--cell-bg-color)",
                  //   color: "var(--text-color)",
                  // }}
                  >
                    {/* <Dropdown.Item
                    onClick={() => handleShowProjects("InviteClientUser")}
                  >
                    Invite Client User
                  </Dropdown.Item> 
                    
                       style={{ backgroundColor: "var(--cell-bg-color)" }}
                       onClick={() => setShowCompany(true)}
                     > 
                    */}

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setShowCompany(true)}>
                    Add Client Company
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ButtonGroup>
          )}

            {/* <TableDownloader
              columns={columns}
              rows={rows}
              fileName="projects_data.csv"
            /> */}
        </div>
      </Box>
        {loading ? (
          <Loader />
        ) : (
          <Box style={{ width: "100%" }}>
            <DataGrid
              rows={getFlattenedRows()}
              columns={columns}
              getRowId={(row) => row.id || new Date().toString()}
              // hideFooter
              pagination
              pageSizeOptions={[25, 50, 75, 100]}
              onPaginationModelChange={setPaginationModal}
              paginationModel={paginationModal}
              loading={loading}
              // slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              disableSelectionOnClick
              autoHeight
            />

            {/* Menu for Action Button Options */}
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleView}>
                <CiViewList className="me-2" />
                View Details
              </MenuItem>
              <MenuItem onClick={handleViewDitailstab}>
                <MdViewQuilt className="me-2" />
                View Details in New Tab
              </MenuItem>
              <MenuItem onClick={handleCopylink}>
                <PiCopyFill className="me-2" />
                Copy Link
              </MenuItem>
              <MenuItem onClick={handleClone}>
                <FaClone className="me-2" />
                Clone
              </MenuItem>
            </Menu>
          </Box>
        )}
      </div>
    </>
  );
};

export default ClientUser;
